import { QueryClient, queryOptions } from '@tanstack/react-query';
import { getSimulation } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep data fresh for 30 seconds
      staleTime: 30 * 1000,
      // Cache data for 5 minutes
      gcTime: 5 * 60 * 1000,
      // Retry failed requests 2 times
      retry: 2,
      // Don't refetch on window focus (SSE handles real-time updates)
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

// Query keys for type safety and consistency
export const queryKeys = {
  simulations: ['simulations'] as const,
  simulation: (id: string) => ['simulation', id] as const,
  features: (simulationId: string) => ['features', simulationId] as const,
  teams: (simulationId: string) => ['teams', simulationId] as const,
  deliverables: (simulationId: string) => ['deliverables', simulationId] as const,
  teamDeliverables: (teamId: string) => ['teamDeliverables', teamId] as const,
};

// Query options factories (for use in both loaders and hooks)
export const simulationQueryOptions = (id: string) =>
  queryOptions({
    queryKey: queryKeys.simulation(id),
    queryFn: () => getSimulation(id),
  });
